import { render, staticRenderFns } from "./technicians.vue?vue&type=template&id=0ff13a9e&scoped=true"
import script from "./technicians.vue?vue&type=script&lang=js"
export * from "./technicians.vue?vue&type=script&lang=js"
import style0 from "./technicians.vue?vue&type=style&index=0&id=0ff13a9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ff13a9e",
  null
  
)

export default component.exports